<template>
    <div class="specialist">
        <router-link :to="{name: 'specialists'}" style="cursor:pointer; display:flex"><span class="material-icons">undo</span>назад</router-link>
        <div v-if="doctor" class="specInfo">
            <div class="avatar">
                <photo v-if="!doctor.employee.avatar" style="height:300px; width:250px; border:2px lightgray solid" />
                <img v-else :src="doctor.employee.avatar" style="height:300px; border:2px lightgray solid"/>
            </div>
            <div class="shortInfo">
                <h4 style="margin-bottom:2rem">{{fullName}}</h4>
                <h5 style="margin:0">Специализация:</h5>
                <span class="short">{{doctor.specialty.title}}</span>
                <h5 style="margin:0">Стаж работы:</h5>
                <span class="short">{{plural(doctor.experience, 'год', 'года', 'лет')}}</span>
                <h5 style="margin:0">Квалификация:</h5>
                <span class="short">{{doctor.degree}}</span>
                <br/>
                <b-button style="margin-top:2rem" variant="success">Записаться</b-button>
            </div>
        </div>
        <hr/>
        <div v-if="doctor" class="description">
            <h5>Полное описание:</h5>
            <p style="white-space: break-spaces">
                {{doctor.fullinfo}}
            </p>
        </div>

        <template v-if="loading">
        <b-container>

            <div style="display:flex; flex-direction:row">
            <div class="avatar">
                <b-skeleton-img height="350px" width="18rem">

                </b-skeleton-img>
            </div>
            <div class="shortInfo">
                <b-skeleton width="400px"></b-skeleton>
                <h5 style="margin:0">Специализация:</h5>
                <b-skeleton width="500px"></b-skeleton>
                <h5 style="margin:0">Стаж работы:</h5>
                <b-skeleton width="100px"></b-skeleton>
                <h5 style="margin:0">Квалификация:</h5>
                <b-skeleton width="200px"></b-skeleton>
                <br/>
               <b-skeleton type="button"></b-skeleton>
            </div>
        </div>
        </b-container>
        </template>
    </div>
</template>

<script>
import { doctorApi } from '@app/services';
import photo from '@app/assets/icons/camera.svg?inline';

export default {
    components: {
        photo
    },
    data() {
        return {
            doctor: null,
            loading: false
        };
    },
    computed: {
        fullName() {
            return `${this.doctor.employee.lastName} ${this.doctor.employee.firstName} ${this.doctor.employee.middleName}`;
        }
    },
    mounted() {
        this.loading = true;
        if (this.$route.params.id) {
            doctorApi.get(this.$route.params.id).then(res => {
                console.log(res);
                this.doctor = res;

            }).catch(error => {
                console.log(error);
            }).finally(res => {
                this.loading = false;
            });
        }


    },
    methods: {
        plural(n,str1,str2,str5) {
            return n + ' ' + ((((n%10)==1)&&((n%100)!=11))?(str1):(((((n%10)>=2)&&((n%10)<=4))&&(((n%100)<10)||((n%100)>=20)))?(str2):(str5)));
        }
    }

};
</script>

<style lang="scss" scoped>
.specialist {
    width:100%;
    padding: 1rem 8rem 1rem 8rem;
}
.shortInfo {
    padding: 1rem 4rem 1rem 4rem;
}
.short {
    font-size:18px;
    margin-bottom: 2rem;
}
.specInfo {
    display:flex;
    flex-direction:row
}
@media screen and (max-width: 1024px) {
.specialist {
    width:100%;
    padding: 1rem;
}
.specInfo {
    display:flex;
    flex-direction:column;
}
}
</style>